export const iconFontAwesomeMedicalHealthHeartCircleMinus = (
	<i className="fa-solid fa-heart-circle-minus"></i>
);
